import { ScreeningStatus } from "shared/types";

export const screeningStatusTitle = (status?: string) => {
  switch (status) {
    case ScreeningStatus.Processing:
      return "In progress";
    case ScreeningStatus.Completed:
      return "Complete";
    case ScreeningStatus.Failed:
      return "Error";
    case ScreeningStatus.Reverifying:
      return "Re-verifying";
    default:
      return "Not started";
  }
};
